class UpsellProduct extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.variantId;
    this.addButton = null;

    // ✅ Only use cart-drawer
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.addButton = this.querySelector('.upsell-add-button');
    if (this.addButton) {
      this.addButton.addEventListener('click', this.addToCart.bind(this));
    }
  }

  async addToCart() {
    if (!this.variantId || !this.cartDrawer) return;

    const formData = new FormData();
    formData.append('id', this.variantId);
    formData.append('quantity', 1);

    formData.append(
      'sections',
      this.cartDrawer.getSectionsToRender().map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    };

    try {
      const response = await fetch('/cart/add.js', config);
      const cartData = await response.json();

      if (response.ok) {
        this.cartDrawer.setActiveElement(this.addButton);
        this.cartDrawer.renderContents(cartData); // ✅ this one works
      }
    } catch (err) {
      console.error('[UpsellProduct] Error adding to cart:', err);
    }
  }
}

customElements.define('upsell-product', UpsellProduct);
